
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-consulting-services",
      function () {
        return require("private-next-pages/ai-consulting-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-consulting-services"])
      });
    }
  